import { css, Global } from '@emotion/react';
import React from 'react';

export const reset = css`
  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }
  .pds-icon {
    flex-shrink: 0;
  }
`;

export const GlobalStyle = () => <Global styles={reset} />;
